import { ReactJSXElement } from "@emotion/react/types/jsx-namespace"
import { useLayoutEffect, useRef, useState } from "react"
import InfoIcon from "../assets/icons/info-icon"
import { useAssessmentStore } from "../shared/store"
import JobDetailSummary from "./job-detail-summary"
import Progress from "./progress-bar"
import { QUESTION_TYPE } from "../shared/constants/assessment-flow"

type ShellProps = {
    footerElement?: ReactJSXElement
    children?: ReactJSXElement
}

const Shell = ({ footerElement, children }: ShellProps) => {
    const { currentStep, assesmentQuestions } = useAssessmentStore((state) => state)
    const footerRef = useRef<HTMLElement>(null)
    const [footerHeight, setFooterHeight] = useState<string>()
    const questionType = assesmentQuestions?.questions[currentStep].question_type
    // To accomodate asset type question
    const title =
        questionType === QUESTION_TYPE.ASSET
            ? assesmentQuestions?.questions[currentStep].page_title
            : assesmentQuestions?.questions[currentStep].questions[0]?.data?.title
    useLayoutEffect(() => {
        setFooterHeight(`${footerRef.current?.offsetHeight || 0}px`)
    }, [])

    return (
        <div className="w-full relative h-screen">
            <div
                style={{
                    boxShadow:
                        "0px 0px 5px rgba(0, 0, 0, 0.05), 0px 25px 35px rgba(0, 0, 0, 0.03)",
                    height: 160,
                }}
            >
                <JobDetailSummary />
            </div>
            <div
                style={{ height: `calc(100vh - calc(${footerHeight} + 160px))` }}
                className="flex flex-col justify-between overflow-auto pb-4"
            >
                <div className="flex flex-col gap-8">
                    {/* {questionType !== QUESTION_TYPE.ASSET && } */}
                    <div className="pl-4 pr-4">
                        <Progress />
                    </div>
                    <div className="flex flex-col gap-3 pl-4 pr-4">
                        <div className="font-semibold text-base text-primary">
                            {title}
                        </div>
                        <div className="flex gap-1">
                            {assesmentQuestions?.questions[currentStep].questions[0]?.data
                                ?.sub_title && (
                                <>
                                    <InfoIcon />
                                    <span className="text-onSurface-secondary text-xs">
                                        {
                                            assesmentQuestions?.questions[currentStep]
                                                .questions[0]?.data?.sub_title
                                        }
                                    </span>
                                </>
                            )}
                        </div>
                        {children}
                    </div>
                </div>
            </div>
            <footer
                ref={footerRef}
                className="fixed bottom-0 w-full overflow-y-scroll pt-2"
            >
                <div className="flex flex-col gap-4 items-center justify-center">
                    {footerElement}
                </div>
            </footer>
        </div>
    )
}

export default Shell
